/*
 * @Author: zsf
 * @Date: 2024-08-14 14:08:56
 * @fileName: 
 * @LastEditTime: 2024-09-23 09:36:21
 * @Description: 
 */

import env from './env'
export const VIDEO_URL = 'https://cdn.tianbang.com/%E7%89%A9%E6%B5%81%E7%B3%BB%E7%BB%9F/%E7%89%A9%E6%B5%81%E7%B3%BB%E7%BB%9F%E5%8F%B8%E6%9C%BA%E7%AB%AF%E8%A7%86%E9%A2%91%E6%95%99%E7%A8%8B.mp4';
// 密码强度校验 同时包含大小写字母+数字+特殊字符
export const PWD_REGEX = /^(?=.*[0-9])(?=.*[A-Za-z])(?=.*[\W_])(?=.*[\S]).{8,12}$/;
// 角色枚举
export const ROLE_LIST = {
  17: '承运商',
  12: '普通司机',
  13: '冷链司机',
  99: '签收人',
  98: '签收人',
  '99S': '签收人',
}
// 异常上报原因
export const EXCEPTION_REASON = [
  '无库存',
  '货物数量不一致',
  '货物不匹配',
  '其他原因'
]
// 订单定位范围 1公里
export const LOCATION_RANGE = 1000;
// 冷链订单状态
export const COLD_ORDER_STATUS = {
  0: "待配送",
  1: "配送中",
  2: "已配送"
}
// 冷链订单颜色
export const COLD_ORDER_COLOR = {
  0: "#FF8A1C",
  1: "#25B5FF",
  2: "#EBEBEB"
}
// 微信消息跳转的页面
export const msgPageList = ['waitSignList', 'signEdit', 'signedPage', 'normalDetail']
// 车辆附件预览接口
const fileUrlMap = {
  localhost: 'http://10.35.2.86:5566',
  dev: 'http://10.35.2.85:5566',
  test: 'http://10.35.2.86:5566',
  prod: 'https://vmp.tianbang.com',
  sgProd: 'https://vmp.scigene.cn',
};
export const fileUrl = fileUrlMap[env]; //车辆



// WEBPACK FOOTER //
// ./src/utils/constant.js